import angular from 'angular';
import _ from 'lodash';
import uiRouter from '@uirouter/angularjs';
import routing from './end_user_edit.routes';
import EndUserService from '../../../components/api/end_user/end_user.service';
import SaConfigService from '../../../components/api/sa_config/sa_config.service';
import ControllerConfigService from '../../../components/api/controller_config/controller_config.service';

export class EndUserEditController {
  /*@ngInject*/
  constructor($stateParams, EndUserService, $q, $state, $mdDialog, $templateCache, $auth, SaConfigService, ControllerConfigService) {
    this.userData = {};
    this.userData.id = $stateParams.id;
    this.currentUserEmail = $auth.user.email;
    this.EndUserService = EndUserService;
    this.SaConfigService = SaConfigService;
    this.ControllerConfigService = ControllerConfigService;
    $templateCache.put('role_table.html', require('./../role_table.html'));
    this.$state = $state;
    this.$mdDialog = $mdDialog;
    this.$q = $q;
    this.selectedIds = [];
    this.editDialog = {
      confirm: $mdDialog.confirm({
        clickOutsideToClose: true,
        title: '変更しますか？',
        ok: '変更する',
        cancel: '戻る'
      }),
      success: $mdDialog.alert({
        clickOutsideToClose: true,
        title: '変更しました',
        ok: 'OK'
      })
    };
    this.deleteDialog = {
      confirm: $mdDialog.confirm({
        clickOutsideToClose: true,
        title: '削除してよろしいですか？',
        ok: '削除する',
        cancel: '戻る'
      }),
      success: $mdDialog.alert({
        clickOutsideToClose: true,
        title: '削除しました',
        ok: 'OK'
      })
    };
    this.errorAlert = $mdDialog.alert()
      .title('エラーが発生しました')
      .content('時間を置いて再試行しても解決しない場合は、IIJサポートセンターにお問い合わせください。')
      .ok('OK');
  }

  $onInit() {
    this.EndUserService.api.show({id: this.userData.id},
      response => {
        this.userData = response;
        this.isSelf = (response.email === this.currentUserEmail)
        if(this.userData.role === 'limited_viewer') {
          this.selectedIds = this.userData.config_ids;
        }
      },
      err => {
        if (err.status === 404 || err.status === 403) {
          this.$state.go('main.home');
        }
      }
    );

    this.$q.all([
      this.SaConfigService.api.index().$promise,
      this.ControllerConfigService.api.index().$promise
    ]).then(responses => {
      this.devices = responses[0].concat(responses[1]);
    });
  }

  updateUser(ev) {
    if(this.userData.role === 'limited_viewer') {
      _.merge(this.userData, { config_ids: this.selectedIds });
    }
    this.$mdDialog.show(this.editDialog.confirm.targetEvent(ev))
      .then(() => {
        this.EndUserService.api.update(
          this.userData,
          (okResponse) => { this.$mdDialog.show(this.editDialog.success).finally(() => { this.$state.go('main.end_user_index'); }); },
          (errResponse) => { this.$mdDialog.show(this.errorAlert); }
        );
      });
  }

  deleteUser(ev) {
    this.$mdDialog.show(this.deleteDialog.confirm.targetEvent(ev))
      .then(() => {
        this.EndUserService.api.delete(
          {id: this.userData.id},
          (okResponse) => { this.$mdDialog.show(this.deleteDialog.success).finally(() => { this.$state.go('main.end_user_index'); }); },
          (errResponse) => { this.$mdDialog.show(this.errorAlert); }
        );
      });
  }
}

export default angular.module('leptonApp.endUserEdit', [uiRouter, EndUserService, SaConfigService, ControllerConfigService])
  .config(routing)
  .component('endUserEdit', {
    template: require('./end_user_edit.html'),
    controller: EndUserEditController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/end_user/edit/end_user_edit.component.js